import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const credentialPortal = {
    namespaced: true,
    state: {
        users: [],
        portales: [],
        portalCredentials: {},
        loading: false,
    },
    mutations: {
        setUsersData(state, data) {
            state.users = data.users || [];
            state.portales = data.portales || [];
        },
        setPortalCredentials(state, { portalId, data }) {
            state.portalCredentials = {
                ...state.portalCredentials,
                [portalId]: data
            };
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    getters: {
        getUsers(state) {
            return state.users;
        },
        getPortales(state) {
            return state.portales;
        },
        getAdminUser(state) {
            return state.users.find(u => u.is_admin) || null;
        },
        getSubUsers(state) {
            return state.users.filter(u => !u.is_admin);
        },
        isLoading(state) {
            return state.loading;
        },
    },
    actions: {
        fetchUsers({ commit }, params = {}) {
            commit('setLoading', true);
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/credenciales-portales/admin/users`, { params })
                    .then(response => {
                        const data = response.data.data;
                        commit('setUsersData', data);
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        commit('setLoading', false);
                    });
            });
        },

        fetchPortalCredentials({ commit }, portalId) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/credenciales-portales/admin/portal/${portalId}/credentials`)
                    .then(response => {
                        const data = response.data.data;
                        commit('setPortalCredentials', { portalId, data });
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // eslint-disable-next-line no-empty-pattern
        saveCredential({}, { portalId, userId, formData }) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/credenciales-portales/admin/portal/${portalId}/user/${userId}`, formData)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // eslint-disable-next-line no-empty-pattern
        deleteCredential({}, { portalId, userId }) {
            return new Promise((resolve, reject) => {
                apiClient.delete(`${apiUrl}/v2/credenciales-portales/admin/portal/${portalId}/user/${userId}`)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // eslint-disable-next-line no-empty-pattern
        assignCredentials({}, { portalId, credentialId, userIds, oauthOwnerUserId, isOAuth }) {
            const body = isOAuth
                ? { oauth_owner_user_id: oauthOwnerUserId, user_ids: userIds }
                : { credential_id: credentialId, user_ids: userIds };
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/credenciales-portales/admin/portal/${portalId}/assign`, body)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // eslint-disable-next-line no-empty-pattern
        unassignCredentials({}, { portalId, userIds }) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/credenciales-portales/admin/portal/${portalId}/unassign`, {
                    user_ids: userIds
                })
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // eslint-disable-next-line no-empty-pattern
        toggleSyncStatus({}, { portalId, userId }) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/credenciales-portales/admin/portal/${portalId}/toggle-status/${userId}`)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        // eslint-disable-next-line no-empty-pattern
        deleteShare({}, shareId) {
            return new Promise((resolve, reject) => {
                apiClient.delete(`${apiUrl}/v2/credenciales-portales/admin/share/${shareId}`)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
};

export default credentialPortal;
